// components/ext/PromptEditorModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message, Select } from 'antd';

const { Option } = Select;

const PromptEditorModal = ({ open, onClose, currentTemplates, onSave, socket, initialType = 'oneWord', initialIndex = 0 }) => {
  const [form] = Form.useForm();
  // Локальные стейты для выбранного типа шаблона и версии
  const [selectedType, setSelectedType] = useState(initialType);
  const [selectedIndex, setSelectedIndex] = useState(initialIndex);

  // При открытии модального окна устанавливаем значения по умолчанию
  useEffect(() => {
    if (open && currentTemplates) {
      const type = initialType || 'oneWord';
      const index = initialIndex || 0;
      setSelectedType(type);
      setSelectedIndex(index);

      let initialTemplate = '';
      if (type === 'oneWord' && currentTemplates.oneWordPrompts && currentTemplates.oneWordPrompts[index]) {
        initialTemplate = currentTemplates.oneWordPrompts[index].static;
      } else if (type === 'twoWord' && currentTemplates.twoWordPrompts && currentTemplates.twoWordPrompts[index]) {
        initialTemplate = currentTemplates.twoWordPrompts[index].static;
      }
      form.setFieldsValue({ template: initialTemplate });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, currentTemplates, form]);

  // Синхронизируем selectedType и selectedIndex с пропсами initialType и initialIndex
  useEffect(() => {
    if (open && currentTemplates) {
      setSelectedType(initialType);
      setSelectedIndex(initialIndex);
    }
  }, [initialType, initialIndex, open, currentTemplates]);

  // Обновление содержимого поля шаблона при смене выбранного типа или версии
  useEffect(() => {
    if (currentTemplates && open) {
      let newTemplate = '';
      if (selectedType === 'oneWord' && currentTemplates.oneWordPrompts && currentTemplates.oneWordPrompts[selectedIndex]) {
        newTemplate = currentTemplates.oneWordPrompts[selectedIndex].static;
      } else if (selectedType === 'twoWord' && currentTemplates.twoWordPrompts && currentTemplates.twoWordPrompts[selectedIndex]) {
        newTemplate = currentTemplates.twoWordPrompts[selectedIndex].static;
      }
      form.setFieldsValue({ template: newTemplate });
    }
  }, [selectedType, selectedIndex, currentTemplates, form, open]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const password = prompt('Введите пароль для сохранения шаблона');
      if (!password) {
        message.error('Пароль обязателен');
        return;
      }
      // Отправляем тип шаблона и индекс версии вместе с новым текстом
      socket.emit('save_template', { 
        password, 
        template: values.template, 
        templateType: selectedType, 
        index: selectedIndex 
      }, (response) => {
        if (response.status === 'ok') {
          message.success(response.message);
          // Обновляем локальный объект с шаблонами
          let updatedTemplates = { ...currentTemplates };
          if (selectedType === 'oneWord') {
            updatedTemplates.oneWordPrompts[selectedIndex].static = values.template;
          } else {
            updatedTemplates.twoWordPrompts[selectedIndex].static = values.template;
          }
          onSave(updatedTemplates);
          onClose();
        } else {
          message.error(response.message || 'Ошибка при сохранении шаблона');
        }
      });
    } catch (error) {
      console.error('Ошибка валидации:', error);
    }
  };

  return (
    <Modal
      open={open}
      title="Редактирование шаблона промпта"
      onCancel={onClose}
      centered
      width="min(960px, 92vw)"
      bodyStyle={{ maxHeight: '80vh', overflowY: 'auto', width: '100%' }}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          Сохранить
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item label="Язык">
          <Select
            value={selectedType}
            onChange={(value) => {
              setSelectedType(value);
              // При смене языка сбрасываем вариант на первый
              setSelectedIndex(0);
            }}
          >
            <Option value="oneWord">Русский</Option>
            <Option value="twoWord">Английский</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Варианты нейминга">
          <Select
            value={selectedIndex}
            onChange={(value) => setSelectedIndex(value)}
          >
            <Option value={0}>Одно слово</Option>
            <Option value={1}>Словосочетание</Option>
            <Option value={2}>Фантазийное</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="template"
          label="Шаблон (статическая часть)"
          rules={[{ required: true, message: 'Заполните шаблон' }]}
        >
          <Input.TextArea rows={6} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PromptEditorModal;
